import getStore from '../store/store';

export function getOWAConnectedAccountStoreState(): boolean {
    return getStore().isAccountsStoreInitialized;
}
